import { SIMAElementClassifier, SIMAProfilePointType, } from "../types";
/**
 * 縦断測点 (H01 レコード)。
 * キャメルケースの直接フィールドを持ち、toPointData() でワイヤフォーマットに変換します。
 */
export class ProfileStation {
    classifier = SIMAElementClassifier.PROFILE_POINT;
    pointName;
    chainage;
    groundElevation;
    stakeElevation;
    pointType;
    constructor(data) {
        this.pointName = data?.pointName ?? data?.point_name ?? "";
        this.chainage = data?.chainage ?? 0;
        this.groundElevation = data?.groundElevation ?? data?.ground_elevation ?? 0;
        this.stakeElevation = data?.stakeElevation ?? data?.stake_elevation ?? 0;
        this.pointType =
            data?.pointType ?? data?.point_type ?? SIMAProfilePointType.REGULAR;
    }
    get point_name() {
        return this.pointName;
    }
    set point_name(val) {
        this.pointName = val;
    }
    get point_type() {
        return this.pointType;
    }
    set point_type(val) {
        this.pointType = val;
    }
    get isChangePoint() {
        return this.pointType === SIMAProfilePointType.CHANGE_POINT;
    }
    toPointData() {
        return {
            classifier: SIMAElementClassifier.PROFILE_POINT,
            point_name: this.pointName,
            chainage: this.chainage,
            ground_elevation: this.groundElevation,
            stake_elevation: this.stakeElevation,
            point_type: this.pointType,
        };
    }
}
/**
 * 縦断測量成果 (H00..H99 ブロック)。
 * 路線番号 (routeNumber) と路線名 (routeName) を持ち、測点を chainage 順で保持します。
 */
export class LongitudinalProfile {
    routeNumber;
    routeName;
    stations = [];
    constructor(data) {
        this.routeNumber = data?.routeNumber ?? data?.alignment_number ?? 1;
        this.routeName = data?.routeName ?? data?.alignment_name ?? "";
        if (data?.stations) {
            this.stations = data.stations.map((s) => s instanceof ProfileStation ? s : new ProfileStation(s));
            this.sortStations();
        }
    }
    /**
     * 互換用プロパティ (routeNumber に委譲)
     */
    get alignmentNumber() {
        return this.routeNumber;
    }
    set alignmentNumber(val) {
        this.routeNumber = val;
    }
    /**
     * 互換用プロパティ (routeName に委譲)
     */
    get alignmentName() {
        return this.routeName;
    }
    set alignmentName(val) {
        this.routeName = val;
    }
    /**
     * 追加距離 (chainage) の昇順に測点をソートします。
     */
    sortStations() {
        this.stations.sort((a, b) => a.chainage - b.chainage);
    }
    /**
     * 測点を追加し、昇順ソートを維持します。
     */
    addStation(station) {
        const instance = station instanceof ProfileStation ? station : new ProfileStation(station);
        this.stations.push(instance);
        this.sortStations();
        return instance;
    }
    /**
     * 追加距離または測点名から測点を検索します。
     */
    findStation(chainageOrName) {
        if (typeof chainageOrName === "number") {
            return this.stations.find((s) => Math.abs(s.chainage - chainageOrName) < 1e-5);
        }
        return this.stations.find((s) => s.pointName === chainageOrName);
    }
    /**
     * 追加距離の範囲 [min, max] を取得します。
     */
    get chainageRange() {
        if (this.stations.length === 0) {
            return [0, 0];
        }
        return [
            this.stations[0].chainage,
            this.stations[this.stations.length - 1].chainage,
        ];
    }
    /**
     * ワイヤフォーマット (ISIMAProfile 構造) に変換します。
     */
    toProfileData() {
        return {
            alignment_number: this.routeNumber,
            alignment_name: this.routeName,
            stations: this.stations.map((s) => s.toPointData()),
        };
    }
}
//# sourceMappingURL=profile.js.map